import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../hooks/hooks';
import { ModalPropsI } from '../../interfaces/modal';
import UploadFile from '../UploadFile/UploadFile';
import { useFetchFileListQuery, useRemoveFileMutation } from '../../store/modalSlice';
import { FileI } from '../../interfaces/appealsAPI';
import FormControl from '@mui/material/FormControl';
import { IconButton, Button, InputLabel } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Delete } from '@mui/icons-material';
import { grey } from '@mui/material/colors';



interface Event<T = EventTarget> {
  target: T;
}

const ModalForm = (props: ModalPropsI) => {         
  const {
    appealId,
    appealDate,
    dateResponse,
    appealResponseText,
    appealDraftText,
    appealFio,
    appealLogin,
    appealEmail,
    appealPhone,
    appealAddress,
    appealQestion,
    appealHistory,
    appealFiles,
    appealQuestionStatus,
    handleCloseModal,
    changeResponse,
    changeDraft,
    responsePattern,
  } = props;
  const { isOpen, type } = useAppSelector((state) => state.modal);
  const [removeFile] = useRemoveFileMutation();                                  // выбор файлов, прикрепленных к ответу
  const [text, setText] = useState('');                                         // состояние ответа на обращение
  const [selectAnswer, setSelectAnswer] = useState('');                        // состояние шаблона ответа

  const [selectedFiles, setSelectedFiles] = useState<Array<File>>([]);
  // const [uploadFile, { error: errorUpload, data: response, isSuccess: isSuccessUpload }] = useUploadFileMutation();


  const handleSend = () => {                                                 // функция отправки письма
    if (text) {
      changeResponse({
        id: appealId,
        response: text,
        statusForEmail: appealQuestionStatus 
      }); 
    } else {
      alert ('Заполните поле "Ответ"')
    }
  };

  const handleChangeSelect = (event: SelectChangeEvent) => {     // выбор темы из шаблонов
    setSelectAnswer(event.target.value as string);
    setText(event.target.value);
  };

  const handleSaveNote = () => {
    changeDraft({ id: appealId, draft: text });      // отправка черновика на сервер
  };

  const {
    data: responseFileList,
    isLoading,
    error,
  } = useFetchFileListQuery({ appealId, type });


  useEffect(() => {
    if (appealResponseText?.trim()) {          // проверка на наличие ответа (убираем пробелы)
      setText('');                            // поле "Ответ" всегда пустое, так как все подтягивается из истории
    } else if (appealDraftText?.trim()) {     // если есть черновик - показываем черновик
      setText(appealDraftText);
    } else {
      setText('');
    }
  }, [appealId, appealResponseText, appealDraftText]);


  const renderFileList = (obj: Array<FileI> | undefined) => {
    return (
      obj && obj.map((el) => {
        // @ts-ignore
        const fileName = el.path.match(/\/([^\/]+)$/)[1];
        return (
          <li key={el.file_id}>
            <a href={`https://${el.path}`} download>
              {fileName}
            </a>
            <IconButton
              onClick={() => {
                removeFile(el.file_id);
              }}
              color="primary"
              aria-label="upload file"
              component="button"
            >
              <Delete />
            </IconButton>
          </li>
        );
      })
    );
  };

  const fileList = renderFileList(responseFileList);


  // const onChangeFile = async (e: Event<HTMLInputElement>) => {
  //   const files = e.target.files;
  //   if (files) {
  //     setSelectedFiles(prevFiles => [...prevFiles, ...Array.from(files)])    // добавления файлов, загруженных пользователем в массив
  //   }
  // };



    // const changeFn = (event: ChangeEvent<HTMLInputElement>) => {
    //   const { name, value, files } = event.target
    //   if (files) {
    //     setFiles(prevFiles => [...prevFiles, ...Array.from(files)])    // добавления файлов, загруженных пользователем в массив
    //   } else {
    //     setFormState(prevState => ({
    //       ...prevState,
    //       [name]: value,
    //     }))
    //   }
    // }



  // const handleFileRemove = (fileToRemove: File) => {      // удаление файла, который добавил пользователь
  //   setFiles (prevFiles => prevFiles.filter(file => file !== fileToRemove))
  // }

  // const handleFileOpen = (file: File) => {        // открытие файл для просмотра в новом окне
  //   const fileUrl = URL.createObjectURL(file)
  //   window.open(fileUrl, '_blank')
  // }



  // const handleUpload = async () => {
  //   const formData = new FormData();
  //   for (let i = 0; i < selectedFiles.length; i++) {
  //     formData.append('appealfile[]', selectedFiles[i]);
  //   }
  //   formData.append('appealId', appealId);

  //   try {
  //     await uploadFile({ formData, type }).unwrap();
  //     setSelectedFiles([]);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };



  const filesLinks = appealFiles?.map((el, idx) => (                                               // файлы, прикрепленные к обращению (без превью, название: файл 1, файл 2 и т.д.)
    <a href={el} target="_blank" rel="noreferrer" key={idx} className="email-link">
      файл {idx + 1}
    </a>
  ));


  return (
    <Dialog 
      open={isOpen}
      onClose={handleCloseModal}
      fullWidth
      PaperProps={{                   
        sx: {
          maxWidth: '95%', 
          height: '90vh',
          position: 'fixed', 
          top: '50%',
          transform: 'translateY(-50%)',   // центруем по вертикали
        },
      }}
    >
      <DialogTitle style={{ display: 'flex', justifyContent: 'flex-start', gap: '50px' }}>
        Обращение № {appealId} {dateResponse !== null ? (<div>дата ответа: {dateResponse}</div>) : null}
      </DialogTitle>

      <div style={{display: 'flex', flexDirection: 'column'}}>
        <div style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>     
          <DialogContent style={{ maxWidth: '55%', maxHeight: '500px', overflowY: 'auto' }}>
            {appealHistory && 
              appealHistory.map((item, index) => (
                <div key={index}>
                  <div>
                    <div style={{fontSize: '12px', color: 'gray'}}>
                      {item.DATE_QUESTION}
                    </div>
                    <div>
                      {item.QUESTION}
                    </div>
                  </div>
                  
                  <div style={{textAlign: 'right', paddingTop: '10px'}}>
                    {/* background: '#DBEFF6' borderRadius: '5px' */}
                    <div style={{fontSize: '12px', color: 'gray'}}>
                      {item.DATE_RESPONSE}      
                    </div>
                    <div>{item.RESPONSE}</div>
                  </div>
                </div>
              ))
            }
          </DialogContent>

          <DialogContent>
            <TextField
              label="Ответ"
              multiline
              fullWidth
              rows={21}    // количество строк (высота поля ответа)
              // variant="standard"
              variant="outlined"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </DialogContent>
        </div>
      

        <div style={{ margin: 'auto', padding: '0 2em', width: '45%' }}>
          <FormControl fullWidth>
            <InputLabel>Шаблон Ответа</InputLabel>
            <Select value={selectAnswer} label="Шаблон Ответа" onChange={handleChangeSelect} style={{ height: '50px' }}>
              {responsePattern.map(({ name, value }, index) => (
                <MenuItem key={index} value={value}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div style={{display: 'flex', flexDirection: 'row', gap: '30px', justifyContent: 'flex-start'}}>
        <div style={{width: '35%', margin: '5px 0 5px 5px', border: '1px solid gray', borderRadius: '5px', boxShadow: '1px 1px 2px gray'}}>
          <div style={{padding: '10px 0 10px 10px', display: 'flex', flexDirection: 'column', gap: '6px', justifyContent: 'space-between'}}>
            {appealFio !== null ? <div style={{fontWeight: 800}}>{appealFio}</div> : null}
            {appealLogin !== null ? <div style={{fontWeight: 800}}>{appealLogin}</div> : null}
            {appealEmail !== null ? <div>{appealEmail}</div> : null}
            {appealPhone !== null ? <div>{appealPhone}</div> : null}
            {appealAddress !== null ? <div>{appealAddress}</div> : null}
          </div>
        </div>
       
        <div style={{width: '30%', marginTop: '5px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: '4px'}}>
          {appealResponseText ? (           // если есть response, то показываем только кнопку "Отправить", если есть draft или "", то  поазываем "Сохранить черновик" и  "Отправить"
            <Button variant="contained" onClick={handleSend}>
              Отправить
            </Button>
            ) : (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: '10px'}}>   
              <Button style={{ color: 'grey' }} onClick={handleSaveNote}>
                Сохранить черновик
              </Button>
              <Button variant="contained" onClick={handleSend}>
                Отправить
              </Button>
            </div>
          )}               
        
          {/* <Button variant="outlined" component="label">
            Прикрепить файлы:
            <input
              onChange={onChangeFile}
              multiple
              hidden
              type="file"
              name="appealfile"
              id="appealFileInput"
              width={'30%'}
            />
          </Button> */}

            {/* 
               style={{display: 'none'}}
                    type='file'
                    multiple
                    id='file-upload'
                    onChange = {changeFn}
                    isInvalid={validated}
                    accept='image/*,.pdf' */}

          <UploadFile id={appealId} type={type} />
        </div>

        <div style={{width: '35%', display: 'flex', flexDirection: 'row', justifyContent: 'space-betwen', alignItems: 'flex-start', gap: '30px'}}>
          {/* файлы, который крепит инспектор к ответу */}
          <ul>{fileList}</ul>      
          {/* файлы, которые пришли ОТ заявителя */}

          {appealFiles?.length ? (
            <div style={{width: '65%'}}>
              <div className="table__info-subtitle">Файлы из обращения № {appealId}</div>
              <div className="table__info-files">{filesLinks}</div>
            </div>
          ) : null} 
        </div>
      </div>
   
    </Dialog>
  );
};
export default ModalForm;